import { trackEvent } from './ComponentHelper'

const buildEventInfo = (eventName, eventData, eventAction) => {
  return {
    eventInfo: {
      eventName,
      eventAction,
      ...eventData
    }
  }
}

const buildAttributes = (attributeData) => {
  return attributeData ? { attributes: { ...attributeData } } : null
}

const trackDataLayerEvent = (eventName, eventData, attributeData, eventAction = 'cms interaction') => {
  trackEvent(
    {
      ...buildEventInfo(eventName, eventData, eventAction),
      ...buildAttributes(attributeData)
    },
    window
  )
}

const joinLinkTitles = (links, linkTitlesArray) => {
  if ((links === null || links.length === 0) && linkTitlesArray.length === 0) {
    return 'NA'
  }

  links.forEach((linkElement) => {
    const title = (linkElement?.title || linkElement?.linkTitle || '').replace(/,/g, '&comma;')
    linkTitlesArray.push(title)
  })

  return linkTitlesArray.filter((title) => title).join('|')
}

const joinContentLinkTitles = (links, linkTitlesArray, type, consumingGridType = 'Isolated', position = 'NA') => {
  if ((links === null || links.length === 0) && linkTitlesArray.length === 0) {
    return 'NA'
  }

  const linkTitle = (linkElement) => (linkElement?.title || linkElement?.linkTitle || '').split(',').join('')

  links.forEach((linkElement) => {
    const title = `${consumingGridType} - ${type} - ${position} - ${linkTitle(linkElement)}`
    linkTitlesArray.push(title)
  })

  return linkTitlesArray.filter((title) => title).join(',')
}

const trackLoadWithoutLink = ['M022', 'C006', 'C009']

// To be removed once all components use new tracking functions
const createGolDataAttributes = (
  consumingGridType = 'isolated',
  componentType = 'component - NA', // component type + position in grid
  title = 'NA', // linkTitle
  link,
  parentHeading, // component heading
  action = 'Click',
  event = 'ev_cmsComponentClick'
) => {
  const isLoad = action === 'Load'
  const [comp] = componentType.split(' - ')
  const linkTitle = title.replace(/,/g, '&comma;')
  if (!link && isLoad && !trackLoadWithoutLink.includes(comp)) return {}
  return {
    'data-name': isLoad ? 'ev_cmsComponentLoad' : event,
    'data-category': 'CMS Component',
    'data-action': action,
    'data-label': `${consumingGridType} - ${componentType} - ${linkTitle}`,
    ...(link && !isLoad && { 'data-destination': link }),
    ...(parentHeading && !isLoad && { 'data-parent': parentHeading })
  }
}

const createGolContentDataAttributes = (
  consumingGridType = 'Isolated',
  componentType = 'component - NA', // component type + position in grid
  title = 'NA', // linkTitle
  link,
  parentHeading, // component heading
  action = 'Click',
  isMultiLink = false
) => {
  const isLoad = action === 'Load'
  const isView = action === 'View'
  const isClick = action === 'Click'
  const [comp] = componentType.split(' - ')
  const linkTitle = isLoad ? title : title.split(',').join('')
  if (!link && isLoad && !trackLoadWithoutLink.includes(comp)) return {}
  let eventName
  let eventAction
  if (isLoad) {
    eventName = 'ev_cmsComponentLoad'
    eventAction = 'Load'
  } else if (isView) {
    eventName = 'ev_cmsComponentView'
    eventAction = 'Impression'
  } else {
    eventName = 'ev_cmsComponentClick'
    eventAction = action
  }
  return {
    'data-name': eventName,
    'data-category': 'CMS Component',
    'data-action': eventAction,
    'data-label': `${!isMultiLink || !isLoad ? `${consumingGridType} - ${componentType} - ` : ''}${linkTitle}`,
    ...(link && isClick && { 'data-destination': link }),
    ...(parentHeading && isClick && { 'data-parent': parentHeading })
  }
}

// used for components with classification that is not "Content" (Navigation/Interaction)
const createGolNonContentDataAttributes = (hitType, action, category, label, classification) => {
  return {
    hit_type: hitType,
    'data-event-action': action,
    'data-event-category': category,
    'data-event-label': label,
    'data-component-classification': classification
  }
}

const eventNames = {
  afsBannerInView: 'afsBannerViewed',
  afsBannerClicked: 'afsBannerClicked',
  afsDrawerCloseX: 'afsCreditPlan_Close',
  afsDrawerCloseKeepOnShopping: 'afsCreditPlan_KeepOnShopping',
  afsOffersHereClicked: 'afsCreditPlan_OffersHere',

  cmsStickyBarAnchorLink: 'cmsStickyBarAnchorLink',

  hotspotClicked: 'hotspotClicked',
  cmsAccordionOpen: 'accordionOpen',
  cmsAccordionClose: 'accordionClose',
  expandCmsAccordion: 'Expand accordion',
  collapseCmsAccordion: 'Collapse accordion',
  carouselViewed: 'cms_carousel_viewed',
  carouselInteraction: 'cms_carousel_interaction',

  ugcViewed: 'ugcViewed',
  ugcQuickViewNext: 'socialMediaLbCarouselNext',
  ugcQuickViewPrev: 'socialMediaLbCarouselPrevious'
}

const attributeNames = {
  hotspotComponentId: 'hotspotComponentId',
  accordion: 'accordion'
}

export {
  trackDataLayerEvent,
  createGolDataAttributes,
  createGolContentDataAttributes,
  createGolNonContentDataAttributes,
  eventNames,
  attributeNames,
  joinLinkTitles,
  joinContentLinkTitles
}
